import Rails from '@rails/ujs'
import '@hotwired/turbo-rails'
import * as ActiveStorage from '@rails/activestorage'

import StimulusControllers from '../../ui/stimulus'

Rails.start()
ActiveStorage.start()
StimulusControllers.start()

document.addEventListener(
  'turbo:frame-missing',
  e => {
    e.preventDefault()
  },
  false
)
